module.exports = __webpack_public_path__ + "static/media/C20-0321_Bistro_Burger_Mobile_767x845.ed56cb73.jpg";